import { useId, useRef, useState } from 'react';
import { MessageSquare, X } from 'lucide-react';
import FeedbackForm from './FeedbackForm';
import { useLocation } from 'react-router-dom';

export default function FeedbackButton({ roomCode }: { roomCode?: string }) {
  const dialog = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  const [opened, setOpened] = useState(false);
  const [context, setContext] = useState<string>();
  return <>
    <button type="button" className="ev-feedback-trigger" onClick={() => { if (!opened) setContext(roomCode); setOpened(true); dialog.current?.showModal(); }}><MessageSquare size={16} aria-hidden="true" /> Send feedback</button>
    <dialog ref={dialog} className="ev-feedback-dialog ev-paper" aria-labelledby={titleId} onClick={event => { if (event.target === event.currentTarget) dialog.current?.close(); }}>
      <div className="ev-feedback-heading"><h2 id={titleId} className="ev-display">A note for Evoke</h2><button type="button" className="ev-icon-button" aria-label="Close feedback" onClick={() => dialog.current?.close()}><X size={20} /></button></div>
      {opened && <FeedbackForm roomCode={context} onNew={() => setContext(roomCode)} />}
    </dialog>
  </>;
}

// Outside the keyed game board: round transitions never discard a feedback draft.
export function FeedbackFooter() {
  const { pathname } = useLocation();
  const roomCode = /^\/room\/([A-Z0-9]{6})$/.exec(pathname)?.[1];
  if (pathname.startsWith('/admin') || pathname === '/feedback') return null;
  return <footer className="evoke-ui ev-feedback-footer"><FeedbackButton roomCode={roomCode} /></footer>;
}
